import { login, logout, getUserInfo } from '@/api/modules/user'
import { getScreenToken, setScreenToken, removeScreenToken, setUserName, removeUserName, setKey, getKey, removeKey } from '@/utils/auth'
// import fa from "element-ui/src/locale/lang/fa";


const state = {
  token: getScreenToken(),
  key: getKey(),
  userName: '',
  roles: [],
  isLoading: false
}
const getters = {
  token: state => state.token,
  key: state => state.key,
  userName: state => state.userName,
  roles: state => state.roles,
  isLoading: state => state.isLoading
}
const mutations = {
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USERNAME: (state, userName) => {
    state.userName = userName
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_KEY: (state, key) => {
    state.key = key
  },
  SET_IS_LOADING: (state, isLoading) => {
    state.isLoading = isLoading
  }
}
const actions = {
  GET_USER_INFO ({commit}, token) {
    return new Promise((resolve, reject) => {
      getUserInfo(token).then(res => {
        const userName = res.data.user_name
        const roles = res.data.roles
        commit('SET_ROLES', roles)
        commit('SET_USERNAME', userName)
        resolve(roles)
      }).catch(error => {
        reject(error)
      })
    })
  },
  SET_SHIPS_TOKEN ({commit}, token) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', token)
      setScreenToken(token)
      setUserName('山东海运')
      resolve()
    })
  },
  // user login
  LOGIN({ commit }, userInfo) {
    // const { phone, password } = userInfo
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        // console.log(response)
        if (response.code !== 0 ) {
          return false
        }
        commit('SET_IS_LOADING', true)
        const { data } = response
        commit('SET_USERNAME', data.alias_name)
        // console.log(data.alias_name)
        commit('SET_TOKEN', data.token)
        commit('SET_KEY', data.key)
        setScreenToken(data.token)
        setUserName(data.alias_name)
        setKey(data.key)
        resolve()
      }).catch(error => {
        commit('SET_IS_LOADING', false)
        reject(error)
      })
    })
  },
  // user logout
  LOGOUT({ commit }, token) {
    return new Promise((resolve, reject) => {
      logout(token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USERNAME', '')
        commit('SET_ROLES', [])
        commit('SET_IS_LOADING', false)
        removeScreenToken()
        removeUserName()
        removeKey()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  SET_IS_LOADING({ commit }, value) {
    commit('SET_IS_LOADING', value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
